<template>
    <div class="position-box">
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title">{{$t('chongzhi.title')}}</div>
            <img class="record" v-if="theme" src="@/assets/theme/jilu.png" @click="record" alt="">
            <img class="record" v-else src="@/assets/dingdan.png" @click="record" alt="">
        </div>
        <div class="cotainer withdraw">
            <div class="select-box" @click="select" v-if="lang == 'ar'">
                <img class="arrow" v-if="theme" style="margin: 0 .3rem 0 0" src="@/assets/theme/icon_back.png" alt="">
                <img class="arrow" v-else style="margin: 0 .3rem 0 0" src="@/assets/alb/icon_back.png" alt="">
                <div class="t2">{{$t('bzxz.title')}}</div>
                <div class="t1">{{currency}}</div>
            </div>
            <div class="select-box" @click="select" v-else>
                <div class="t1">{{currency}}</div>
                <div class="t2">{{$t('bzxz.title')}}</div>
                <img class="arrow" v-if="theme" src="@/assets/theme/jiantou_white.png" alt="">
                <img class="arrow" v-else src="@/assets/user/jiantou.png" alt="">
            </div>
            <div class="tips">{{$t('chongzhi.t7')}}</div>
            <ul class="chain-box">
                <li class="chain" :class="{active: tabIdx == index}" v-for="(item,index) in addressList" :key="index" @click="change(item.value,item.address,index)">{{item.value}}</li>
            </ul>
            <div class="ewm-box">
                <div class="ewm-img"><qriously :value="address" :size="125"/></div>
                <a class="btn-save" download="QR.png" :href="downLoadUrl">{{$t('chongzhi.t9')}}</a>
                <div class="t1">{{$t('chongzhi.t10')}}</div>
                <div class="t2">{{address}}</div>
                <div class="btn-copy" @click="copy($event)">{{$t('assets.copyaddress')}}</div>
            </div>
            <div class="tips">{{$t('chongzhi.t1')}}</div>
            <div class="input-box"><input class="input number" type="number" v-model="number" min="0" @keyup="keyMoney()" :placeholder="$t('chongzhi.t2')"><div class="t1"></div><div class="t2" style="display:none">{{$t('hyjy.qb')}}</div></div>
            <div class="tips">{{$t('chongzhi.t3')}}</div>
            <div class="input-box"><input class="input" type="text" v-model="certificate" :placeholder="$t('chongzhi.t4')"></div>
            <div class="tips">{{$t('chongzhi.t5')}}</div>
            <div class="upload-box" v-if="certificate_url"><img class="upload" @click="upload" :src="certificate_url" alt=""></div>
            <div class="upload-box" v-else><img class="upload" v-if="theme" @click="upload" src="@/assets/theme/upload.png" alt=""><img class="upload" v-else @click="upload" src="@/assets/my2/btn-upload.png" alt=""></div>
            <template v-if="lang == 'ar'">
              <div class="tips-text"><div>{{$t('chongzhi.tips2')}}</div><div>.1</div></div>
              <div class="tips-text"><div>{{$t('chongzhi.tips3')}}</div><div>.2</div></div>
              <div class="tips-text"><div>{{$t('chongzhi.tips4')}}</div><div>.3</div></div>
              <div class="tips-text">{{$t('chongzhi.tips5')}}</div>
            </template>
           <template v-else>
               <div class="tips-text">{{$t('chongzhi.tips2')}}</div>
              <div class="tips-text">{{$t('chongzhi.tips3')}}</div>
              <div class="tips-text">{{$t('chongzhi.tips4')}}</div>
              <div class="tips-text">{{$t('chongzhi.tips5')}}</div>
            </template>
        </div>
        <div class="load-box" v-show="isLoad" @click="hideLoad"><img class="load" src="@/assets/loading.gif" alt=""></div>
         <button class="btn-login btn-bg" @click="sure">{{$t('chongzhi.t6')}}</button>
         <input class="___input" type="file" ref="foreheadCir" mutiple="mutiple" accept="image/*" style="display: none;">
    </div>
</template>

<script>
import QRCode from "qrcode2";
import lrz from "lrz";
export default {
    name: 'deposit',
    data () {
        return {
          token: '',
          theme: false,
          isLoad: false,
          tabIdx: 0,
          currency: 'USDT',
          addressList: [],
          address: '',
          chain: '',
          number: '',
          type: '',
          certificate: '',
          certificate_url: '',
          tag: '',
          downLoadUrl: '',
          count: 1,
          lang: 'en'
        }
    },
    created(){
      this.token = localStorage.getItem('token');
      this.theme = JSON.parse(localStorage.getItem('theme'));
      this.type = this.$route.query.type || 1;
      this.currency = localStorage.getItem('bz') || 'USDT';
      this.lang = localStorage.getItem('language') || 'en';
    },
    mounted() {
        this.getChainList();
    },
    methods: {
       back(){
           this.$router.push('/user')
       },
       record(){
           this.$router.push('/records')
       },
       change(chain,ads,idx){
           this.tabIdx = idx;
           this.chain = chain;
           this.address = ads;
       },
       select(){
           this.$router.push({ path: '/selectCurrency', query: { type: 1,url: 'deposit' } })
       },
       getChainList(){
           let params = {
               currency: this.currency
           }
           this.$ajax.get('/web/getChainList',{params}).then((res) => {
                let resData = res.data.data;
                if(resData.length > 0){
                    this.addressList = resData;
                    this.address = resData[0].address;
                    this.chain = resData[0].value;
                    var imgData = $("canvas")[0].toDataURL('png');
                    this.downLoadUrl = imgData;
                }else{ //暂未开放充值
                    // this.$router.push('/user')
                }
            }).catch(function(err){
                console.log(err)
            })
       },
       sure(){
           var params = {
                'number': this.number,
                'address': this.address,
                'currency': this.currency,
                'type': this.type,
                'certificate_url': this.certificate_url,
                'certificate': this.certificate,
                'chain': this.chain,
                'tag': this.tag
            };
            if(params.number == '' || params.number == null || params.number <= 0){
                this.$toast.center(this.$t('chongzhi.t2'));
                return false;
            }
            if(this.count == 1){
              this.count = 0;
            }else{
                return false;
            }
            this.$ajax.post('/web/assetRecharge',params).then((res) => {
                let resData = res.data;
                if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                    this.$toast.center(resData.message);
                    setTimeout(() => {
                      this.count = 1;
                      this.$router.push('/records')
                    }, 1000)
                }else{
                    this.count = 1;
                    this.$toast.center(resData.message);
                    return;
                }
            }).catch(function(err){
                console.log(err)
            })
       },
      upload(){
          var that = this;
          this.uploadimg(function (res) {
              that.certificate_url = res.url
          })
      },
      uploadimg(callback){
			    let that = this;
			    that.ele_input(function(res) {
            if (res.length > 0) {
              var formdata = new FormData();
              for (var i = 0, len = res.length; i < len; i++) {
                lrz(res[0]).then(function (rst) {
                  var formdata = new FormData();
                  let file = new window.File([rst.file],rst.origin.name, {type: rst.file.type});
                  formdata.append('file', file);
                  formdata.append('token', that.token);
                  formdata.append('app', 'h5');
                  that.isLoad = true;
                  $.ajax({
                    url: that.domain + "/web/uploadImg",
                    type: "POST",
                    data: formdata,
                    cache: false,
                    processData: false,
                    contentType: false,
                    success: function(data) {
                      if (typeof data == 'string') data = JSON.parse(data.data)
                      if (data && data.code == 0) {
                        that.isLoad = false;
                        that.certificate_url = data.data.url;
                      }else{
                        that.isLoad = false;
                        that.$toast.center(data.message);
                        return;
                      }
                    },error: function(data) {
                      that.isLoad = false;
                      that.$toast.center(data.message);
                      return;
                    }
                  });
                })
              }
            }
			  })
		  },
      ele_input(callback){
        var inputs = document.querySelector('.___input')
        if (!!inputs) {
          inputs.onchange = null
          inputs.onclick = null
        }
        inputs.onchange = function() {
          var arr = []
          for (var i = 0, len = this.files.length; i < len; i++) {
            arr.push(this.files[i])
          }
          callback(arr)
        }
        inputs.click();
      },
      hideLoad(){
          this.isLoad = false;
      },
      copy(e){
          let address = this.address;
          this.$copyText(address, this.$t('kjmb.fzcg'));
          this.$toast.center(this.$t('kjmb.fzcg'));
      },
      keyMoney(){
          this.number = this.number.replace(/[^\d.]/g, "");  //仅保留数字和"."
          this.number = this.number.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
          this.number = this.number.replace(".", "$#*").replace(/\./g,'').replace('$#*','.');//去除其他"."
          this.number = this.number.replace(/^(\d+)\.(\d\d\d\d).*$/, '$1.$2');;//限制只能输入两个小数
          if (this.number.indexOf(".") < 0 && this.number != "") { //首位是0的话去掉
              this.number = parseFloat(this.number);
          }
      },
    }
}
</script>
<style scoped>
    .position-box{
        background: #fff;
    }
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        padding: 0 .44rem;
        color: #000;
        line-height: 1.6rem;
        background: #fff;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .5rem;
        margin-top: -.4rem;
    }
    .head .title{
        font-size: .56rem;
    }
    .head .record{
        position: absolute;
        top: 50%;
        right: .3rem;
        width: .6rem;
        height: .6rem;
        margin-top: -.3rem;
    }
    .cotainer{
        position: absolute;
        top: 1.6rem;
        bottom: 1.82rem;
        width: 100%;
        padding: 0 .48rem;
        background: #fff;
        box-sizing: border-box;
        overflow-y: scroll;
    }
    .select-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 1.3rem;
        margin: .48rem 0 0;
        padding: 0 .44rem;
        background: #f9f9f9;
    }
    .select-box .t1{
        flex: 1;
        color: #000;
        font-size: .48rem;
    }
    .select-box .t2{
        color: #a9a9a9;
        font-size: .4rem;
    }
    .select-box .arrow{
        width: .2rem;
        margin-left: .3rem;
    }
    .tips{
        padding: .6rem 0;
        color: #000;
        font-size: .4rem;
    }
    .chain-box{
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }
    .chain-box .chain{
        width: 2.59rem;
        height: 0.96rem;
        margin: 0 .4rem .4rem 0;
        color: #a9a9a9;
        font-size: .4rem;
        line-height: .96rem;
        background-color: #f7f7f7;
        border-radius: 0.48rem;
        text-align: center;
    }
    .chain-box .chain.active{
        color: #fff;
        background-color: #588bf8;
    }
    .ewm-box{
        padding: .44rem .4rem .7rem;
        background: #f9f9f9;
        text-align: center;
    }
    .ewm-box .ewm-img{
        width: 3.66rem;
        height: 3.6rem;
        margin: auto;
    }
    .ewm-box .btn-save{
        display: inline-block;
        /* width: 3.12rem; */
        height: 0.96rem;
        margin: .38rem auto .56rem;
        padding: 0 .3rem;
        color: #218adc;
        font-size: .4rem;
        line-height: .96rem;
        background-color: #e8f5ff;
        border-radius: 0.48rem;
        border: solid 0.01rem #218adc;
        text-align: center;
    }
    .ewm-box .t1{
        color: #a9a9a9;
        font-size: .38rem;
    }
    .ewm-box .t2{
        padding: .48rem 0 .42rem;
        color: #000;
        font-size: .36rem;
    }
    .ewm-box .btn-copy{
        width: 3.12rem;
        height: 0.96rem;
        margin: 0 auto;
        color: #1f1f1f;
        font-size: .38rem;
        line-height: .96rem;
        background-color: #fff4dd;
        border-radius: 0.48rem;
        text-align: center;
    }
    .input-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #ececec;
    }
    .input-box .input{
        flex: 1;
        padding: .32rem 0;
        font-size: .4rem;
    }
    .input-box .input::placeholder{
        color: #d7d7d7;
        font-size: .42rem;
    }
    .input-box .t1{
        padding: 0 .3rem;
        color: #a6a6a6;
        font-size: .48rem;
        /* border-right: 1px solid #d7d77d; */
    }
    .input-box .t2{
        padding-left: .3rem;
        color: #000;
        font-size: .48rem;
    }
    .upload-box{
        padding: 0 0 .7rem;
    }
    .upload{
        width: 3.3rem;
        height: 3.3rem;
    }
    .btn-login{
        position: fixed;
        left: .44rem;
        right: .44rem;
        bottom: .42rem;
        width: 9.92rem;
    }
    .tips-text{
      display: flex;
      /* justify-content: flex-end; */
      padding: .15rem 0;
      color: #000;
      font-size: .36rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/deposit.vue